export default __webpack_public_path__ + "static/joko-app-screenshot-home-2-en-0681ab3f360ac1a8fb80e4649c8cf613.webp";